import React, { useEffect, useState } from 'react';
import is from 'is_js';

import { MinusIcon, PlusIcon } from 'icons';

function QuantityButton({
    quantity,
    changeQuantity,
    disabled,
    increaseQuantity,
    decreaseQuantity,
}) {
    const [currentQuantity, setQuantity] = useState(quantity);

    const handleInputQuantity = (value) => {
        if (is.integer(parseInt(value))) {
            setQuantity(value);

            changeQuantity(value);
        }
    };

    useEffect(() => {
        setQuantity(quantity);
    }, [quantity]);

    return (
        <div id="quantity-minus-plus">
            <div className="button-container">
                <button
                    type="button"
                    className="button"
                    style={{ borderRight: 'none' }}
                    onClick={decreaseQuantity}
                    disabled={quantity === 0}
                    data-test="quantity-minus"
                >
                    <MinusIcon data-test="minus-button" />
                </button>

                <input
                    type="number"
                    value={currentQuantity}
                    onChange={(e) => handleInputQuantity(e.target.value)}
                    className="quantity"
                    data-test="quantity"
                />

                <button
                    type="button"
                    className="button"
                    style={{ borderLeft: 'none' }}
                    onClick={increaseQuantity}
                    disabled={disabled ? disabled : false}
                    data-test="quantity-plus"
                >
                    <PlusIcon data-test="plus-button" />
                </button>
            </div>
        </div>
    );
}

export default QuantityButton;
